export var ServiceOverviewSubjects;
(function (ServiceOverviewSubjects) {
    ServiceOverviewSubjects["GroupByButtonGroup"] = "group-by-button-group";
    ServiceOverviewSubjects["ServiceOverviewTable"] = "service-overview-table";
    ServiceOverviewSubjects["SpmGraphThroughput"] = "throughput-spm-graph";
    ServiceOverviewSubjects["SpmGraphErrorRate"] = "error-rate-spm-graph";
    ServiceOverviewSubjects["SpmGraphLatency"] = "latency-spm-graph";
    ServiceOverviewSubjects["SpmGraphHttpStatusCode"] = "http-status-code-spm-graph";
    ServiceOverviewSubjects["InfraGraphCpu"] = "cpu-infra-graph";
    ServiceOverviewSubjects["InfraGraphMemory"] = "memory-infra-graph";
    // OrionIQ chat Layer-2 per-row attach CTAs (ORIONIQ-1384).
    ServiceOverviewSubjects["AttachOperationToAi"] = "attach-operation-to-ai";
    ServiceOverviewSubjects["AttachSpanToAi"] = "attach-span-to-ai";
})(ServiceOverviewSubjects || (ServiceOverviewSubjects = {}));
//# sourceMappingURL=service-overview.enum.js.map